<div class="h-100 flex flex-col">
  <div>
    <div class="flex align-items-center greeting-title">
      <button
        mat-icon-button
        class="back-button"
        (click)="setSelectedPage('Main')">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <h1 class="title mb-0">
        {{ 'VOICE_MAIL_PREFERENCES.MANAGE' | translate }}
        {{
          (audioType === AudioType.greeting
            ? 'VOICE_MAIL_PREFERENCES.GREETING'
            : 'VOICE_MAIL_PREFERENCES.RECORDED_NAME'
          ) | translate
        }}
      </h1>
    </div>
    <div class="content-secondary">
      <mat-form-field
        appearance="outline"
        class="w-100 density-minus-3">
        <mat-label>{{
          (audioType === 'greeting'
            ? 'VOICE_MAIL_PREFERENCES.ENTER_GREETING_NAME'
            : 'VOICE_MAIL_PREFERENCES.ENTER_NAME'
          ) | translate
        }}</mat-label>
        <input
          [(ngModel)]="greetingName"
          (ngModelChange)="validate()"
          autocomplete="off"
          matInput />
      </mat-form-field>
    </div>
    <div class="section">
      <span class="sub-title d-block w-100 border-none">
        {{ 'VOICE_MAIL_PREFERENCES.RECORDING_METHOD' | translate }}
      </span>
      @let brandingData = (brandingService.brandingData$ | async) || defaultBrandingSettings;
      <div class="content">
        <mat-radio-group
          ngDefaultControl
          color="primary"
          class="flex flex-col"
          [(ngModel)]="recordingMethod"
          (ngModelChange)="onRecordingMethodChanged()">
          <mat-radio-button
            [value]="'TextToSpeech'"
            [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"
            >{{ 'VOICE_MAIL_PREFERENCES.TEXT_TO_SPEECH' | translate }}</mat-radio-button
          >
          <mat-radio-button
            [value]="'Upload'"
            [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"
            >{{ 'VOICE_MAIL_PREFERENCES.UPLOAD_OR_RECORD' | translate }}</mat-radio-button
          >
        </mat-radio-group>
      </div>
    </div>
    @if (recordingMethod === 'TextToSpeech') {
      <div class="section">
        <span class="sub-title d-block w-100 border-none">{{ 'VOICE_MAIL_PREFERENCES.MESSAGE' | translate }}</span>
        <div class="content">
          <mat-form-field
            appearance="outline"
            class="w-100 fs-14 density-minus-3">
            <textarea
              [(ngModel)]="ttsScript"
              (ngModelChange)="validate()"
              matInput
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              cdkAutosizeMinRows="5"
              cdkAutosizeMaxRows="7"></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="section">
        <span class="sub-title d-block w-100 border-none">{{ 'VOICE_MAIL_PREFERENCES.LANGUAGE' | translate }}</span>
        <div class="content">
          <mat-form-field
            appearance="outline"
            class="select-dropdown density-minus-3">
            <div class="flex">
              <mat-select
                [(value)]="selectedTTSLanguage"
                (valueChange)="onTtsLanguageChanged($event)">
                @for (language of ttsLanguages; track $index) {
                  <mat-option [value]="language"> {{ language.name }} ({{ language.country }}) </mat-option>
                }
              </mat-select>
            </div>
          </mat-form-field>
        </div>
      </div>
      <div class="section">
        <span class="sub-title d-block w-100 border-none">{{ 'VOICE_MAIL_PREFERENCES.VOICE' | translate }}</span>
        <div class="content flex align-items-center relative">
          @if (isLoadingVoices) {
            <div class="spinner voice-spinner">
              <mat-spinner [diameter]="22"></mat-spinner>
            </div>
          }
          <mat-form-field
            appearance="outline"
            class="select-dropdown density-minus-3">
            <div class="flex">
              <mat-select
                [disabled]="!selectedTTSLanguage"
                [(value)]="selectedTTSVoice"
                (valueChange)="validate()">
                @for (voice of ttsVoices; track $index) {
                  <mat-option [value]="voice"> {{ voice.name }} ({{ voice.type }} {{ voice.subType }}) </mat-option>
                }
              </mat-select>
            </div>
          </mat-form-field>
          <button
            class="play-pause--square"
            (click)="playTtsPreview()"
            color="primary"
            mat-mini-fab
            appBrandingColor
            [brandingField]="BrandingField.FieldColorFontIconsListAreaItems">
            <mat-icon
              aria-hidden="true"
              class="play-track">
              {{ playingAudioId === 'voice' ? 'pause' : 'play_arrow' }}
            </mat-icon>
          </button>
        </div>
      </div>
    }
    @if (recordingMethod === 'Upload') {
      @if (audio === null && recordedFile === null && fileToUpload === undefined) {
        <div class="flex align-items-center m-t-32">
          <button
            [disabled]="isRecording"
            color="primary"
            mat-raised-button
            type="button"
            (click)="handleClickOnUpload()"
            appBrandingColor
            [brandingField]="BrandingField.FieldColorFontIconsListAreaItems">
            {{ 'VOICE_MAIL_PREFERENCES.UPLOAD_A_FILE' | translate }}
          </button>
          <span class="m-r-8 m-l-8">{{ 'VOICE_MAIL_PREFERENCES.OR' | translate }}</span>
          <button
            [disabled]="isRecording"
            color="primary"
            mat-raised-button
            type="button"
            (click)="handleClickOnShowRecorder()"
            appBrandingColor
            [brandingField]="BrandingField.FieldColorFontIconsListAreaItems">
            {{ 'VOICE_MAIL_PREFERENCES.RECORD_NEW' | translate }}
            {{
              (audioType === AudioType.name ? 'VOICE_MAIL_PREFERENCES.NAME' : 'VOICE_MAIL_PREFERENCES.GREETING')
                | translate
            }}
          </button>
        </div>
      }
      <input
        #file
        (change)="onFileSelect($event)"
        type="file"
        class="d-none"
        accept="audio/mpeg, audio/wav" />
      @if (fileToUpload !== undefined) {
        <mat-form-field
          appearance="outline"
          class="w-100 density-minus-3 file-upload-container m-t-32">
          <mat-label>{{ 'VOICE_MAIL_PREFERENCES.FILE_NAME' | translate }}</mat-label>
          <input
            readonly
            [ngModel]="fileToUpload.name"
            (ngModelChange)="validate()"
            autocomplete="off"
            matInput />
        </mat-form-field>
        <div class="w-100 flex justify-content-end">
          <button
            class="action-button"
            (click)="file.click()">
            <mat-icon color="primary">upload</mat-icon>
            <span class="action">{{ 'VOICE_MAIL_PREFERENCES.SELECT_A_DIFFERENT_FILE' | translate }}</span>
          </button>
        </div>
      }
    }
    @if (showRecorder && recordingMethod === 'Upload') {
      @if (recordedFile === null) {
        <div class="recorder relative">
          @if (recorderIsDisabled && isRecording) {
            <div class="spinner recorder-spinner">
              <mat-spinner [diameter]="22"></mat-spinner>
            </div>
          }
          <div class="flex align-items-center">
            <div class="record-icon-container justify-content-center align-items-center">
              @if (!isRecording) {
                <div
                  class="record-icon cursor-pointer"
                  (click)="recordClickHandler()"></div>
              } @else {
                <div
                  class="recording-icon cursor-pointer"
                  (click)="recordClickHandler()"></div>
              }
            </div>
            <div class="track-duration">{{ Number(recordingSeconds) | secondsToMinutes }}</div>
            <div class="voice-mail-slider-container">
              <mat-slider
                disabled
                min="0"
                [max]="audioType === AudioType.name ? 10 : 60"
                step="1"
                ngDefaultControl
                class="voice-mail-slider w-100"
                #ngSlider
                ><input
                  matSliderThumb
                  [(ngModel)]="recordingSeconds"
                  #ngSliderThumb="matSliderThumb"
              /></mat-slider>
            </div>
          </div>
        </div>
      }
      @if (recordedFile !== null && recordingTrack && recordingTrack.duration) {
        <div class="recorder">
          <div class="flex align-items-center">
            <button
              class="play-pause"
              color="primary"
              (click)="onRecordedFilePlayClicked()"
              mat-mini-fab>
              <mat-icon
                aria-hidden="true"
                class="play-track"
                >{{ playingAudioId === 'recorded' ? 'pause' : 'play_arrow' }}
              </mat-icon>
            </button>
            <div class="track-duration">{{ Number(recordingSeconds) | secondsToMinutes }}</div>
            <div class="voice-mail-slider-container">
              <mat-slider
                min="0"
                [max]="recordingTrack.duration"
                step="1"
                ngDefaultControl
                class="voice-mail-slider w-100"
                #ngSlider
                ><input
                  matSliderThumb
                  [(ngModel)]="recordingSeconds"
                  #ngSliderThumb="matSliderThumb"
              /></mat-slider>
            </div>
            <div class="recorder-delete-container">
              <button
                (click)="deleteRecordedFile()"
                color="primary"
                mat-icon-button>
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>
        </div>
      }
    }
    @if (audio !== null && recordingMethod === 'Upload') {
      <div class="recorder">
        <div class="flex align-items-center">
          <button
            class="play-pause"
            color="primary"
            (click)="togglePlayAudio.emit()"
            mat-mini-fab>
            <mat-icon
              aria-hidden="true"
              class="play-track">
              {{ playingAudioId === audio.index ? 'pause' : 'play_arrow' }}
            </mat-icon>
          </button>
          <div class="track-duration">{{ Number(recordingSeconds) | secondsToMinutes }}</div>
          <div class="voice-mail-slider-container">
            <mat-slider
              min="0"
              [max]="Number(audio.duration)"
              step="1"
              ngDefaultControl
              class="voice-mail-slider w-100"
              #ngSlider
              ><input
                matSliderThumb
                [(ngModel)]="recordingSeconds"
                #ngSliderThumb="matSliderThumb"
            /></mat-slider>
          </div>
          <div class="recorder-delete-container">
            <button
              (click)="deleteAudioToEdit()"
              color="primary"
              mat-icon-button>
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </div>
      </div>
    }
  </div>
</div>
